import React from "react";
import DeleteButton from "./DeleteButton/DeleteButton";
import {Box, IconButton, TextField} from "@mui/material";
import {PlusOne} from "@mui/icons-material";

type Props = {
  field: string
  onChange: (event: any) => void
  onDelete: (event: any) => void
  onAdd?: (event: any) => void
}

export default function EditField({field, onChange, onDelete, onAdd}: Props) {
  return (
    <Box sx={{p: '2px 4px', display: 'flex', alignItems: 'center'}}>
      <TextField sx={{ml: 1, flex: 1}} size="small" placeholder="Please enter text" value={field} onChange={onChange} />
      {onAdd && <IconButton onClick={onAdd}><PlusOne/></IconButton>}
      <DeleteButton onClick={onDelete} />
    </Box>
  )
}